import type { EventBusProviderProps } from "./event-bus.type";

import { EventBusContext } from "./event-bus.context";
import { eventBus } from "./event-bus.helper";

export const EventBusProvider = ({ children }: EventBusProviderProps) => {
  return (
    <EventBusContext.Provider value={eventBus}>
      {children}
    </EventBusContext.Provider>
  );
};
